import { useEffect, useRef, useState } from "react";
import DirectUpdaterCard from "./DirectUpdaterCard";
import { getWorkflowIdentity } from "./workflow-api";
import { directUpdaterAccessState } from "./direct-update-ui";
import "./direct-updater.css";

function errorMessage(error) {
  return error instanceof Error ? error.message : String(error);
}

export default function DirectUpdaterWorkspace({ photoReady, renderPhoto, originalPhoto, getAccessToken, confirmShoulderCrop }) {
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");
  const [scope, setScope] = useState(null);
  const tokenProvider = useRef(getAccessToken);
  tokenProvider.current = getAccessToken;

  useEffect(() => {
    let active = true;
    getWorkflowIdentity(() => tokenProvider.current())
      .then(({ identity }) => {
        if (active) {
          setScope(identity?.directUpdaterScope || null);
          setState(directUpdaterAccessState(identity));
        }
      })
      .catch((loadError) => {
        if (active) {
          setError(errorMessage(loadError));
          setState("error");
        }
      });
    return () => { active = false; };
  }, []);

  if (state === "loading") {
    return <div className="panel-section direct-access-state" role="status"><strong>Checking Direct Updater access…</strong></div>;
  }

  if (state !== "allowed") {
    return <div className="panel-section direct-access-state is-denied" role="alert">
      <strong>Direct Updater access required</strong>
      <p>{error || "Your account is not assigned the ProfilePhoto.DirectUpdater role."}</p>
      <a href="/">Back to Profile Picture Studio</a>
    </div>;
  }

  return <div className="panel-section direct-workspace-section">
    <div className="step-number">03</div>
    <div className={`direct-scope-summary ${scope?.mode === 'unavailable' ? 'is-attention' : ''}`} role="status">
      <strong>Authorized company scope</strong>
      <small>{scope?.mode === 'companies'
        ? scope.companyKeys.join(', ')
        : scope?.mode === 'unavailable'
          ? 'Scope is temporarily unavailable. Updates will remain blocked until it can be verified.'
          : 'All companies'}</small>
    </div>
    <DirectUpdaterCard photoReady={photoReady} originalPhoto={originalPhoto} renderPhoto={renderPhoto} getAccessToken={getAccessToken} confirmShoulderCrop={confirmShoulderCrop} />
  </div>;
}
